import "core-js/modules/es6.array.index-of";
import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.function.name";
import { isPitch, altToAcc, isNamed, accToAlt, interval } from '@tonaljs/tonal';
var NoRomanNumeral = {
  empty: true,
  name: "",
  chordType: ""
};
var cache = {};
/**
 * Get properties of a roman numeral string
 *
 * @function
 * @param {string} - the roman numeral string (can have type, like: Imaj7)
 * @return {Object} - the roman numeral properties
 * @param {string} name - the roman numeral (tonic)
 * @param {string} type - the chord type
 * @param {string} num - the number (1 = I, 2 = II...)
 * @param {boolean} major - major or not
 *
 * @example
 * romanNumeral("VIIb5") // => { name: "VII", type: "b5", num: 7, major: true }
 */

function romanNumeral(src) {
  return typeof src === "string" ? cache[src] || (cache[src] = parse(src)) : typeof src === "number" ? romanNumeral(NAMES[src] || "") : isPitch(src) ? fromPitch(src) : isNamed(src) ? romanNumeral(src.name) : NoRomanNumeral;
}
/**
 * Get roman numeral names
 *
 * @function
 * @param {boolean} [isMajor=true]
 * @return {Array<String>}
 *
 * @example
 * names() // => ["I", "II", "III", "IV", "V", "VI", "VII"]
 */


function names() {
  var major = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  return (major ? NAMES : NAMES_MINOR).slice();
}

function fromPitch(pitch) {
  return romanNumeral(altToAcc(pitch.alt) + NAMES[pitch.step]);
}

var REGEX = /^(#{1,}|b{1,}|x{1,}|)(IV|I{1,3}|VI{0,2}|iv|i{1,3}|vi{0,2})([^IViv]*)$/;

function tokenize(str) {
  return REGEX.exec(str) || ["", "", "", ""];
}

var ROMANS = "I II III IV V VI VII";
var NAMES = ROMANS.split(" ");
var NAMES_MINOR = ROMANS.toLowerCase().split(" ");

function parse(src) {
  var _tokenize = tokenize(src),
      _tokenize2 = _slicedToArray(_tokenize, 4),
      name = _tokenize2[0],
      acc = _tokenize2[1],
      roman = _tokenize2[2],
      chordType = _tokenize2[3];

  if (!roman) {
    return NoRomanNumeral;
  }

  var upperRoman = roman.toUpperCase();
  var step = NAMES.indexOf(upperRoman);
  var alt = accToAlt(acc);
  var dir = 1;
  return {
    empty: false,
    name: name,
    roman: roman,
    interval: interval({
      step: step,
      alt: alt,
      dir: dir
    }).name,
    acc: acc,
    chordType: chordType,
    alt: alt,
    step: step,
    major: roman === upperRoman,
    oct: 0,
    dir: dir
  };
}

export { names, romanNumeral, tokenize };